import { Button } from "reactstrap";
import { hasPermission } from "../../utils/commonutils";

const StartFromInquiryCta = ({
  history,
  message,
  inquiryType,
  onDirectAdd,
  directLabel = "Add file",
  directPermission,
}) => {
  const canCreateInquiry = hasPermission("create_inquiry");
  const canDirectAdd = Boolean(onDirectAdd) && (!directPermission || hasPermission(directPermission));
  const search = inquiryType
    ? canCreateInquiry
      ? `?type=${inquiryType}&new=1`
      : `?type=${inquiryType}`
    : canCreateInquiry
      ? "?new=1"
      : "";

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      <span style={{ fontSize: 13, color: "#5a6a85", maxWidth: 280, lineHeight: 1.4 }}>
        {message}
      </span>
      <Button className="btn btn-colored" onClick={() => history.push(`/inquiary${search}`)}>
        {canCreateInquiry ? "New inquiry" : "Open inquiries"}
      </Button>
      {canDirectAdd && (
        <Button className="btn btn-border" onClick={onDirectAdd}>
          {directLabel}
        </Button>
      )}
    </div>
  );
};

export default StartFromInquiryCta;
